module.exports = __webpack_public_path__ + "img/icon01.b3929f8.png";